// 刚刚封装的axios
import request from '../index.js';

// 阈值查询
export const thresholdList = (query) => {
  return request({
      url: '/iotThreshold/getIotThreshold',
      method: 'POST',
      data: query
  })
}
// 阈值添加
export const addThreshold = (query) => {
  return request({
      url: '/iotThreshold/addIotThreshold',
      method: 'POST',
      data: query
  })
}
// 阈值修改
export const alterThreshold = (query) => {
  return request({
      url: '/iotThreshold/updateIotThreshold',
      method: 'PUT',
      data: query
  })
}
// 阈值停用
export const delThreshold = (query) => {
  return request({
      url: '/iotThreshold/delIotThreshold',
      method: 'DELETE',
      params: query
  })
}
// 预警信息
export const alarmList = (query) => {
  return request({
      url: '/iotAlarm/getIotAlarmList',
      method: 'POST',
      data: query
  })
}
// 预警信息导出
export const alarmList2 = (query) => {
  return request({
      url: '/iotAlarm/getIotAlarmList',
      method: 'POST',
      responseType: "blob",
      data: query
  })
}
// 预警信息统计
export const alarmNUm = () => {
  return request({
      url: '/iotAlarm/getTotalAlarm',
      method: 'GET'
  })
}
// 预警信息处理
export const alarmhandle = (query) => {
  return request({
      url: '/iotAlarm/handleMessage',
      method: 'POST',
      data: query
  })
}
// 数据报告列表
export const dataReportList = (query) => {
  return request({
      url: '/dataReport/getIotDataReport',
      method: 'POST',
      data: query
  })
}
// 删除报告
export const delDataReport = (query) => {
  return request({
      url: '/dataReport/delIotDataReport',
      method: 'DELETE',
      data: query
  })
}
// 获取报告设置
export const getDataReportRuleList = (query) => {
  return request({
      url: '/dataReportRuleConf/getDataReportRuleList',
      method: 'POST',
      data: query
  })
}
// 添加报告设置
export const addIotDataReportRuleConf = (query) => {
  return request({
      url: '/dataReportRuleConf/addIotDataReportRuleConf',
      method: 'POST',
      data: query
  })
}
// 删除报告设置
export const deleteReportRus = (query) => {
  return request({
      url: '/dataReportRuleConf/deleteReportRus',
      method: 'DELETE',
      data: query
  })
}
// 根据类型获取站内外ID
export const getDeviceId = (query) => {
  return request({
      url: '/dataReportRuleConf/getDeviceId',
      method: 'GET',
      params: query
  })
}
// 站内历史数据
export const dataHistory = (query) => {
  return request({
      url: '/apiDataHistory/getApiDataList',
      method: 'POST',
      data: query
  })
}
// 站外历史数据
export const dataHistoryOut = (query) => {
  return request({
      url: '/apiDataHistory/getIotDataList',
      method: 'POST',
      data: query
  })
}
// 站内历史数据
export const dataHistory2 = (query) => {
  return request({
      url: '/apiDataHistory/getApiDataList',
      method: 'POST',
      responseType: "blob",
      data: query
  })
}
// 站外历史数据
export const dataHistoryOut2 = (query) => {
  return request({
      url: '/apiDataHistory/getIotDataList',
      method: 'POST',
      responseType: "blob",
      data: query
  })
}
// 消息推送列表
export const pushList = (query) => {
  return request({
      url: '/iotAlarmUser/getAlarmUser',
      method: 'POST',
      data: query
  })
}
// 消息推送 添加
export const addPush = (query) => {
  return request({
      url: '/iotAlarmUser/addAlarmUser',
      method: 'POST',
      data: query
  })
}
// 文件下载
export const download  = (query) => {
  return request({
      url: '/file/download',
      method: 'GET',
      responseType: "blob",
      // responseType: "arraybuffer",
      params: query
  })
}